import { Modal, ModalSizes } from "@centricsoftware/design-system";
import { CANCEL_RES, SAVE_RES } from "csi/components/constants";
import { getSlotContainerName } from "csi/page/ReactPortals/ReactPortals";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { FormStore, FormStoreContext } from "../FormStore";
import { NEW_FORM_DIALOG } from "../index";
import { NewFormFooter } from "./NewFormFooter";
import { StatefulForm } from "./StatefulForm";

const modalContainerName = getSlotContainerName("body");
const modalContainer = () => document.getElementById(modalContainerName);

interface NewFormDialogProps {
	/** store for the form */
	store: FormStore;
	title?: string;
}

export const NewFormDialog: FunctionComponent<NewFormDialogProps> = observer((props) => {
	// TODO - handle the validation 
	const { store, title } = props;
	const {
		formInfo,
		onCancel,
		onValidate,
	} = store;

	return (
		<FormStoreContext.Provider value={store}>
			<Modal
				actionButtonProps={{
					childrenRes: SAVE_RES,
					onClick: onValidate,
				}}
				cancelButtonProps={{
					childrenRes: CANCEL_RES,
					onClick: onCancel,
				}}
				className="csi-modal-dialog-z-index-800"
				// C8-76259 - https://github.com/mui/material-ui/issues/19450#issuecomment-1539832475
				container={modalContainer}
				dataCsiAutomation={NEW_FORM_DIALOG}
				disableEnforceFocus
				footerChildren={<NewFormFooter />}
				onClose={onCancel}
				open
				showActionButton
				showCancelButton
				showFooter
				size={ModalSizes.Medium}
				title={title}
			>
				<StatefulForm formInfo={formInfo} />
			</Modal>
		</FormStoreContext.Provider>
	);
});
